export default class Location {
  name
  provisionedNumber
  practiceUuid
  locationUuid
  inquiryPhone
  constructor (payload) {
    this.name = payload.name
    this.provisionedNumber = payload.provisionedNumber
    this.practiceUuid = payload.practiceUuid
    this.locationUuid = payload.locationUuid
    this.inquiryPhone = payload.inquiryPhone
      ? payload.inquiryPhone.replace(/^\+[0-9]/, '')
      : ''
  }
}
